import React from 'react';
import PropTypes from 'prop-types';

const Input = ({ input, label, type, placeholder, icon, meta: { touched, error } }) => (
  <div className={`form-group ${(touched && error) ? 'has-error' : ''}`}>
    {label && <label className="input-label" htmlFor={input.name}>{label}</label>}
    { icon &&
      <div className="input-icon">
        <i className="material-icons">{icon}</i>
      </div>
    }
    <div>
      <input
        className={`form-control ${icon ? 'left-icon' : ''}`}
        {...input}
        {...{ type, placeholder }}
      />
      {touched && error && <span className="error-message">{error}</span>}
    </div>
  </div>
);

const { string, object } = PropTypes;

Input.propTypes = {
  input: object.isRequired,
  label: string,
  type: string.isRequired,
  placeholder: string,
  icon: string,
  meta: object
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/Input.js